import axiosClient from '../../configs/axios.js';


class SalesReport {

    async getSalesreport(params) {
        try {
            const response = await axiosClient.get(
                `/reports/salesreport`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }





 








   
    
}

export default new SalesReport(); 